import React, { useEffect } from "react";

import { Col, Row } from "react-bootstrap";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";

// ✅ IMPORT API
import {
  PLMonth,
  PLMonthWiseFan,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Profit And Loss/ProfitAndLossSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";

export default function MonthWise({ selectedIds }) {
  console.log(selectedIds);

  const dispatch = useDispatch();

  const firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { PLMonthdata } = useSelector((state) => state.ProFitAndLossSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  useEffect(() => {
    dispatch(PLMonthWiseFan());
    dispatch(
      PLMonth({
        Firm: firm,
        Year: FinancialYear,
        selectedIds: selectedIds,
      }),
    );
  }, [dispatch, firm, FinancialYear, selectedIds]);

  /* ================= FORMAT ================= */

  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  /* ================= DATA ================= */

  const getRows =
    PLMonthdata?.Detail?.map((label, index) => ({
      srNumber: index + 1,
      acname: label.acname,
      GroupMStName: label.GroupMStName,
      AcLaieName: label.AcLaieName?.trim(),
      AprBal: label.AprBal,
      MayBal: label.MayBal,
      JunBal: label.JunBal,
      JulBal: label.JulBal,
      AugBal: label.AugBal,
      SepBal: label.SepBal,
      OctBal: label.OctBal,
      NovBal: label.NovBal,
      DecBal: label.DecBal,
      JanBal: label.JanBal,
      FebBal: label.FebBal,
      MarBal: label.MarBal,
      BalAmt: label.BalAmt,
    })) || [];

  /* ================= COLUMNS ================= */

  const getColumns = [
    { label: "Sr. N o.", key: "srNumber", align: "center" },
    {
      label: "Ac Type",
      key: "AcLaieName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
      width: "180px",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "AcGroup Name",
      key: "GroupMStName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Ac Name",
      key: "acname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total", key: "BalAmt", align: "right", format: true },
    { label: "Apr", key: "AprBal", align: "right", format: true },
    { label: "May", key: "MayBal", align: "right", format: true },
    { label: "Jun", key: "JunBal", align: "right", format: true },
    { label: "Jul", key: "JulBal", align: "right", format: true },
    { label: "Aug", key: "AugBal", align: "right", format: true },
    { label: "Sep", key: "SepBal", align: "right", format: true },
    { label: "Oct", key: "OctBal", align: "right", format: true },
    { label: "Nov", key: "NovBal", align: "right", format: true },
    { label: "Dec", key: "DecBal", align: "right", format: true },
    { label: "Jan", key: "JanBal", align: "right", format: true },
    { label: "Feb", key: "FebBal", align: "right", format: true },
    { label: "Mar", key: "MarBal", align: "right", format: true },
  ];

  const buildGroupTotals = (parentSummary = [], childSummary = []) => {
    const totals = {};

    // -------------------------
    // Parent Summary
    // -------------------------
    parentSummary.forEach((item) => {
      // Parent Level Key
      const parentKey = `-${item.AcLaieName}-0`;

      totals[parentKey] = {
        ...item,
      };
    });

    // -------------------------
    // Child Summary
    // -------------------------
    childSummary.forEach((item) => {
      const childKey = `-${item.AcLaieName}-0-${item.GroupMStName}-1`;

      totals[childKey] = {
        ...item,
      };
    });

    return totals;
  };
  const groupTotals = buildGroupTotals(
    PLMonthdata?.ParentSummary || [],
    PLMonthdata?.ChildSummary || [],
  );

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 10;

    /* ================= TITLE ================= */
    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");

    doc.text("Month Wise Profit & Loss Report", pageWidth / 2, 12, {
      align: "center",
    });

    /* Line above firm name */
    doc.setLineWidth(0.5);
    doc.line(marginX, 15, pageWidth - marginX, 15);

    /* Firm Name */
    const firmName =
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      DataMain?.Firm_List?.[0]?.GroupName ||
      firm ||
      "";

    doc.setFontSize(11);
    doc.text(firmName, pageWidth / 2, 20, {
      align: "center",
    });
    const details = PLMonthdata?.Detail || [];

    /* ================= TOTALS ================= */
    let totals = {
      BalAmt: 0,
      AprBal: 0,
      MayBal: 0,
      JunBal: 0,
      JulBal: 0,
      AugBal: 0,
      SepBal: 0,
      OctBal: 0,
      NovBal: 0,
      DecBal: 0,
      JanBal: 0,
      FebBal: 0,
      MarBal: 0,
    };

    const formatIndianRupee = (amount) =>
      new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount || 0);

    /* ================= ROWS ================= */
    const rows = details.map((r, i) => {
      Object.keys(totals).forEach((k) => {
        totals[k] += Number(r[k] || 0);
      });

      return [
        i + 1,
        r.acname || "",
        formatIndianRupee(r.BalAmt),
        formatIndianRupee(r.AprBal),
        formatIndianRupee(r.MayBal),
        formatIndianRupee(r.JunBal),
        formatIndianRupee(r.JulBal),
        formatIndianRupee(r.AugBal),
        formatIndianRupee(r.SepBal),
        formatIndianRupee(r.OctBal),
        formatIndianRupee(r.NovBal),
        formatIndianRupee(r.DecBal),
        formatIndianRupee(r.JanBal),
        formatIndianRupee(r.FebBal),
        formatIndianRupee(r.MarBal),
      ];
    });

    /* ================= TOTAL ROW ================= */
    const pdfTotal = PLMonthdata?.Summary?.[0] || {};

    rows.push([
      "",
      "TOTAL",
      formatIndianRupee(pdfTotal.BalAmt),
      formatIndianRupee(pdfTotal.AprBal),
      formatIndianRupee(pdfTotal.MayBal),
      formatIndianRupee(pdfTotal.JunBal),
      formatIndianRupee(pdfTotal.JulBal),
      formatIndianRupee(pdfTotal.AugBal),
      formatIndianRupee(pdfTotal.SepBal),
      formatIndianRupee(pdfTotal.OctBal),
      formatIndianRupee(pdfTotal.NovBal),
      formatIndianRupee(pdfTotal.DecBal),
      formatIndianRupee(pdfTotal.JanBal),
      formatIndianRupee(pdfTotal.FebBal),
      formatIndianRupee(pdfTotal.MarBal),
    ]);

    /* ================= COLUMN WIDTH (REBALANCED) ================= */
    const colWidths = [
      10, // Sr (75% reduced)
      30, // Ac Name (INCREASED BIG)
      22, // Total
      22,
      22,
      22,
      22,
      22,
      22,
      22,
      22,
      22,
      22,
      22,
      22,
    ];

    autoTable(doc, {
      startY: 25,
      margin: { left: 8, right: 8 },

      head: [
        [
          "Sr",
          "Ac Name",
          "Total",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
          "Jan",
          "Feb",
          "Mar",
        ],
      ],

      body: rows,

      theme: "grid",

      styles: {
        fontSize: 8,
        valign: "middle",
        textColor: [0, 0, 0],
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        fontSize: 9,
      },

      bodyStyles: {
        fontStyle: "bold",
      },

      columnStyles: {
        0: { halign: "center", cellWidth: colWidths[0] }, // Sr
        1: { halign: "left", cellWidth: colWidths[1] }, // Ac Name
        2: { halign: "right", cellWidth: colWidths[2] }, // Total
        3: { halign: "right" },
        4: { halign: "right" },
        5: { halign: "right" },
        6: { halign: "right" },
        7: { halign: "right" },
        8: { halign: "right" },
        9: { halign: "right" },
        10: { halign: "right" },
        11: { halign: "right" },
        12: { halign: "right" },
        13: { halign: "right" },
        14: { halign: "right" },
      },

      didParseCell: function (data) {
        if (data.row.raw[1] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [235, 235, 235];
        }
      },

      didDrawPage: function () {
        const pageNo = doc.internal.getCurrentPageInfo().pageNumber;
        doc.setFontSize(8);
        doc.text(`Page ${pageNo}`, marginX, pageHeight - 5);
      },
    });

    /* ================= SUMMARY ================= */
    const summary = PLMonthdata?.Summary?.[0] || {};
    const finalY = doc.lastAutoTable.finalY + 10;

    doc.setFontSize(11);
    doc.setFont(undefined, "bold");

    doc.text(`Status : ${summary.Status || ""}`, marginX, finalY);
    doc.text(
      `Amount : ${formatIndianRupee(summary.Amount || 0)}`,
      pageWidth - marginX,
      finalY,
      { align: "right" },
    );

    doc.save("Month_Wise_Report.pdf");
  };

  /* ================= LOADER ================= */

  if (PLMonthdata === "no" || PLMonthdata === null) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Loader />
      </div>
    );
  }

  /* ================= UI ================= */

  return (
    <div
      style={{
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
      }}
    >
      <Row>
        <Col xs={12}>
          <Row
            className="align-items-center"
            style={{
              marginBottom: "10px",
            }}
          >
            {/* Card */}
            <Col xl={6} lg={8} md={12} sm={12}>
              <div
                style={{
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour2,
                  border: `1px solid ${
                    isdark === "light"
                      ? iscolour?.Colour3
                      : iscolourDark?.Colour10
                  }`,
                  borderLeft: `6px solid ${
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour10
                  }`,
                  borderRadius: "12px",
                  padding: "12px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  height: "100%",
                }}
              >
                {/* Amount */}
                <h4
                  style={{
                    marginTop: "10px",
                    fontWeight: "500",
                    color:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour10,
                  }}
                >
                  {formatIndianRupee(PLMonthdata?.Summary?.[0]?.Amount)}
                </h4>

                {/* Title */}
                <h6
                  style={{
                    color:
                      isdark === "light"
                        ? iscolour?.Colour12
                        : iscolourDark?.Colour12,
                    fontWeight: "600",
                  }}
                >
                  {PLMonthdata?.Summary?.[0]?.Status} Amount :{" "}
                </h6>
              </div>
            </Col>

            {/* Button */}
            <Col
              xl={6}
              lg={4}
              md={12}
              sm={12}
              className="d-flex justify-content-xl-end justify-content-lg-end justify-content-md-start mt-md-3 mt-3 mt-lg-0"
            >
              <button
                onClick={handleDownload}
                className="common-hover-btn"
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour4
                      : iscolourDark?.Colour6,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour11
                      : iscolourDark?.Colour12,
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: "pointer",
                  fontWeight: "500",
                  fontSize: "14px",
                  height: "44px",
                }}
              >
                <Download size={16} />
                Download PDF
              </button>
            </Col>
          </Row>

          <div
            style={{
              marginTop: "20px",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour4,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour11,
                padding: "14px",
                margin: 0,
                position: "relative",
                zIndex: 2,
              }}
            >
              <h2
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "600",
                }}
              >
                MONTHWISE
              </h2>
            </div>

            {/* <FASparentMultipalChild
              data={getRows}
              columns={getColumns}
              externalTotals={PLMonthdata?.Summary?.[0] || {}}
              parentTotals={parentTotals}
            /> */}

            <FASparentMultipalChild
              data={getRows}
              columns={getColumns}
              externalTotals={PLMonthdata?.Summary?.[0] || {}}
              groupTotals={groupTotals}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
